<template>
  <div class="space-y-3">
    <div
      v-for="(benefit, index) in benefits"
      :key="index"
      class="flex gap-2 items-center pr-4"
    >
      <svg
        v-if="benefit.icon === 'check'"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="text-success flex-shrink-0"
      >
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
      </svg>
      <svg
        v-else-if="benefit.icon === 'star'"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="text-warning flex-shrink-0"
      >
        <polygon
          points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
        ></polygon>
      </svg>
      <p class="ml-2 text-xs">
        <span v-html="benefit.text" />
        <span v-if="benefit.count">{{ benefit.count }} </span>
      </p>
      <div
        class="whitespace-nowrap flex items-center gap-1 text-xs"
        v-if="benefit.type === 'end'"
      >
        <PowerIcon v-if="benefit.valueUnit === 'power'" />
        <CrystalIcon v-else />
        {{ benefit.value! }}
      </div>
      <div
        class="whitespace-nowrap flex items-center gap-1 text-xs"
        v-else-if="benefit.valueUnit"
      >
        (价值
        <PowerIcon v-if="benefit.valueUnit === 'power'" />
        <CrystalIcon v-else />
        {{ benefit.value! }})
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { MemberPlanBenefit } from "@/views/Crystal/memberData";
import PowerIcon from "@/components/icon/PowerIcon.vue";
import CrystalIcon from "@/components/icon/CrystalIcon.vue";

defineProps<{
  benefits: MemberPlanBenefit[];
}>();
</script>
